import { Component, ChangeDetectionStrategy, AfterViewInit, OnDestroy, ElementRef, ViewChild } from '@angular/core';
import { gsap } from 'gsap';

@Component({
  selector: 'app-executive-jobs',
  standalone: false,
  templateUrl: './executive-jobs.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./executive-jobs.component.scss']
})
export class ExecutiveJobsComponent implements AfterViewInit, OnDestroy {
  @ViewChild('heroSection') heroSection!: ElementRef<HTMLElement>;

  private ctx?: gsap.Context;

  constructor() { }

  ngAfterViewInit(): void {
    if (!this.heroSection?.nativeElement) return;

    this.ctx = gsap.context(() => {
      const motionMedia = gsap.matchMedia();

      motionMedia.add('(prefers-reduced-motion: no-preference)', () => {
        const tl = gsap.timeline({
          defaults: { ease: 'power3.out' }
        });

        // Image wrapper slides in smoothly from the right
        tl.from('.exec-bg-image-wrapper', {
          xPercent: 35,
          opacity: 0,
          duration: 1.4
        }, 0);

        // All text slides in together at once from the left
        tl.from('.exec-intro-text', {
          x: -90,
          opacity: 0,
          duration: 1.2
        }, 0.2);
      });
    }, this.heroSection.nativeElement);
  }

  ngOnDestroy(): void {
    this.ctx?.revert();
  }
}
